<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm8>
        <h1>{{ $t('a') }}</h1>
        <div><small>{{ $t('b') }}</small></div>
        <v-layout wrap justify-center>
          <v-flex xs12 text-center>
            <img :src="images.bottom" height="260px"/>
          </v-flex>
          <v-flex xs8>
            <v-form ref="form" v-model="areFormRulesRespected">
              <v-card class="px-8 py-1">
                <v-layout mt-8 wrap justify-space-between>
                  <v-flex xs5>
                    <locale-selector/>
                  </v-flex>
                  <v-flex xs7> 
                    
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field v-model="firstName" dense :label="$t('c')" background-color="white" prepend-inner-icon="person" outlined :rules="[firstNameRules]"/>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field v-model="lastName" dense :label="$t('d')" prepend-inner-icon="person_outline" outlined :rules="[lastNameRules]"/>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-space-between>
                  <v-flex xs5>
                    <v-text-field v-model="phoneNumber" dense :label="$t('f')" prepend-inner-icon="phone" outlined :rules="[phoneNumberRules]"/>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-6 justify-center>
          <v-flex xs4 v-if="isSavingPending" my-12>
            <v-progress-linear indeterminate color="primary"></v-progress-linear>  
          </v-flex>
          <v-flex xs12 text-center mt-2 mb-12 v-else>
            <v-btn class="secondary" @click="save" :disabled="!areFormRulesRespected || isSavingPending">{{ $t('g') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import store from "@/store";
import { mapGetters } from "vuex";
import LocaleSelector from "@/components/LocaleSelector";

export default {
  components: {
    LocaleSelector
  },
  data: () => ({
    areFormRulesRespected: false,
    isSavingPending: false,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    images: {
      bottom: require('@/assets/app/images/businessman__flatline.svg'),
    }
  }),
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  mounted() {
  },
  methods: {
    firstNameRules(v) {
      if (!v) return this.$t('h')
      return true 
    },
    lastNameRules(v) {
      if (!v) return this.$t('i')
      return true
    },
    phoneNumberRules(v) {
      if (!v) return this.$t('k')
      return true
    },
    save() {
      this.isSavingPending = true  
      this.$functions.httpsCallable('updateUser')({
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber
      }).then(async () => {
        this.$router.push('/onboarding/choose-company')
      })
    },
  },
}
</script>


<i18n>
{
  "fr": {
    "a": "Vous connaître",
    "b": "Étape 1 sur 2",
    "c": "Prénom",
    "d": "Nom de famille",
    "f": "Numéro de téléphone",
    "g": "Suivant",
    "h": "Votre prénom est requis.",
    "i": "Votre nom de famille est requis.",
    "k": "Votre numéro de téléphone est requis."
  },
  "en": {
    "a": "Contact details",
    "b": "Step 1 of 2",
    "c": "First name",
    "d": "Last name",
    "f": "Phone number",
    "g": "Next step",
    "h": "Your first name is required.",
    "i": "Your last name is required.",
    "k": "Your phone number is required."
  }
}
</i18n>
